import { render, staticRenderFns } from "./GoodsCategoryType.vue?vue&type=template&id=cc038fb0&scoped=true&"
import script from "./GoodsCategoryType.vue?vue&type=script&lang=js&"
export * from "./GoodsCategoryType.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCategoryType.vue?vue&type=style&index=0&id=cc038fb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc038fb0",
  null
  
)

export default component.exports